import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const SIZES = {
  sm: { box: 28, icon: 14 },
  md: { box: 36, icon: 16 },
  lg: { box: 44, icon: 22 },
};

// Badge cuadrado con icono. Usado por PageHeader y SectionHeader.
// - tint: color del icono (y del fondo en variant="solid"). Default: colorPrimary.
// - size: 'sm' | 'md' | 'lg'.
// - variant: 'subtle' (fondo neutro + icono tinteado) | 'solid' (fondo tint + icono blanco).
function IconBadge({ icon: Icon, tint, size = 'md', variant = 'subtle' }) {
  const { token } = useToken();
  const resolvedTint = tint ?? token.colorPrimary;
  const { box, icon } = SIZES[size] ?? SIZES.md;

  const palette =
    variant === 'solid'
      ? {
          background: resolvedTint,
          border: `1px solid ${resolvedTint}`,
          color: '#fff',
        }
      : {
          background: token.colorBgLayout,
          border: `1px solid ${token.colorBorder}`,
          color: resolvedTint,
        };

  return (
    <div
      aria-hidden="true"
      style={{
        width: box,
        height: box,
        flexShrink: 0,
        display: 'grid',
        placeItems: 'center',
        borderRadius: token.borderRadius,
        ...palette,
      }}
    >
      <Icon style={{ fontSize: icon }} />
    </div>
  );
}

export default IconBadge;
